export default "__VITE_ASSET__B_S0SAlj__"